import { render } from "./Developer.vue?vue&type=template&id=45888d19&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"

import "./Developer.vue?vue&type=style&index=0&id=45888d19&scoped=true&lang=scss"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/spider-web-gp-tools-s3-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45888d19"]])

export default __exports__